import { currentYear } from '@/utils'
import dayjs from 'dayjs'
import { range } from 'ramda'

export const makeDates = (
  month?: string | number,
  year?: string | number,
): number[] => {
  let max: number
  if (!month) {
    max = 31
  } else {
    max = dayjs(`${year || currentYear()}-${month}-01`).daysInMonth()
  }

  return range(1, max + 1)
}
